import { getUiLocale } from './locale';

type CountryLike = {
  countryAbbreviation?: string;
  country?: string;
  countryName?: string;
};

function regionLocale() {
  const ui = getUiLocale();
  if (ui === 'vi-VN') {
    return 'vi';
  }
  if (ui === 'zh-CN') {
    return 'zh-CN';
  }
  return 'en';
}

/** 地点下拉：中文锁现网 countryName；英/越用区号对应的本地化地区名。 */
export function countryDisplayName(item?: CountryLike | null) {
  if (!item) {
    return '';
  }
  const code = String(item.countryAbbreviation || '').trim().toUpperCase();
  if (getUiLocale() === 'zh-CN') {
    return item.countryName || item.country || code;
  }
  if (code) {
    try {
      // TS 3.8 的 lib 没有 Intl.DisplayNames，运行时浏览器有
      const DisplayNames = (Intl as unknown as {
        DisplayNames?: new (locales: string[], options: { type: 'region' }) => { of(code: string): string | undefined };
      }).DisplayNames;
      const name = DisplayNames
        ? new DisplayNames([regionLocale()], { type: 'region' }).of(code)
        : undefined;
      if (name) {
        return name;
      }
    } catch {
      // 非法区号时退回接口英文名
    }
  }
  return item.country || item.countryName || code;
}
